<template>

   <ModalWithTabs  :show="showNotic" :tabs="tabs"  @close="closeModal()"></ModalWithTabs>
</template>

<script>
// import UiModal from '@/components/ui-modal.vue'

import ModalWithTabs from '../../../components/ui-prize.vue';
import Tab1Content from './tab2content.vue';
import Tab2Content from './tab1content.vue';
import { mapState } from 'vuex'

export default {
  components: { ModalWithTabs },
  inject: ['json_config'],
  props: {},
  data() {
    return {
      showNotic: false,
      loading: false,
      tabs: [
        { name: '奖金', component: Tab2Content, iconType: 'prize' },
        { name: '奖金规则', component:  Tab1Content, iconType: 'rule'},
      ]
    }
  },
  created() {
    // console.log(123)
  },
  computed: {
    ...mapState(['token']),
    config() {
      return this.json_config()
    }
  },
  methods: {
    showModal() {
      this.showNotic = true
    },
    closeModal() {
      this.showNotic = false
    },
    handleAgree() {}
  }
}
</script>

<style lang="scss" scoped>
.inner-content {
  width: 780px;
  height: 286px;
  // width: 880px;
  // height: 508px;
  margin: 35px auto 26px;
  overflow: hidden;

  .scroll-box {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    white-space: pre-line;

    .center {
      width: 780px;
      height: 379px;
    }
    .title {
      // font-size: 26px;
      font-size: 26px;
      font-weight: 600;
      color: #333;
      // font-style: normal;
      line-height: 150%;
    }
    p {
      color: #666;
      font-size: 20px;
      margin-right: 10px;
      font-weight: 400;
      line-height: 150%;
    }
  }
}
.agree-box {
  width: 100%;
  background-color: #f4f4f4;
  text-align: center;
  .btn {
    width: 388px;
    height: 58px;
    margin: 20px auto 26px;
    background: #fee000;
    box-shadow: 0px 2px 0px #e7cb00, 0px -2px 0px #fff18b;
    border-radius: 10px;
    font-size: 24px;
    color: #000;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    &:active {
      opacity: 0.8;
    }
  }
}
</style>